// CSS ko <style> tag ke andar daalna
var style = document.createElement('style');
style.innerHTML = `
  /* FAQ Section ko center karna */
  .faq-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 50px auto; /* FAQ ke aas-paas spacing */
    padding: 20px;
    width: 80%; /* Width ko limit karna */
    max-width: 900px; /* Section ka maximum width */
  }

  /* Har FAQ item ka style */
  .faq-item {
    margin-bottom: 15px;
    width: 100%; /* Container ke full width mein item ko fit karna */
  }

  /* Question button ka style */
  .faq-question {
    background-color: #f1f1f1;
    padding: 15px;
    border: 1px solid #ccc;
    width: 100%;
    text-align: left;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    display: block;
    margin: 0 auto; /* Center karna */
  }

  /* Answer box ka style */
  .faq-answer {
    display: none;
    background-color: #fafafa;
    padding: 12px;
    margin-top: 5px;
    border-left: 3px solid #ccc;
  }

  /* Active question ko highlight karna jab click ho */
  .faq-question.active {
    background-color: #e0e0e0; /* Jab question active ho to color change */
  }
`;
document.head.appendChild(style);

// jQuery se FAQ toggle functionality
$(document).ready(function() {
  $(".faq-answer").hide();  // Sabhi answers ko initially hide karna
  $(".faq-question").click(function() {
    $(this).next(".faq-answer").slideToggle();  // Question click hone par answer ko toggle karna
    $(this).toggleClass("active");  // Active question ko highlight karna
  });
});
